import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { useSession } from '@/stores/session';
import { useResolvedTheme } from '@/theme/theme';
import { sendPageview } from './beacon';

/**
 * One beacon per pathname change (query/hash changes are not page views). Renders nothing.
 * Waits until the session is known so an administrator's first page is not sent before the role is.
 */
export function PageviewBeacon(): null {
  const { pathname } = useLocation();
  const theme = useResolvedTheme();
  const status = useSession((s) => s.status);
  const role = useSession((s) => s.me?.role);
  const themeRef = useRef(theme);
  themeRef.current = theme;
  const ready = status !== 'loading';
  useEffect(() => {
    if (ready) sendPageview(pathname, themeRef.current, role);
  }, [pathname, ready, role]);
  return null;
}
